import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { SECTIONS, allFields } from "./sections";

const EXTRA = { resume: "09", certificates: "09", documents: "09", consent: "10", accept_terms: "10" };
export const stepOfError = (key) => {
  if (EXTRA[key]) return SECTIONS.findIndex((s) => s.id === EXTRA[key]);
  return SECTIONS.findIndex((s) => allFields(s).some((f) => f.name === key));
};

export const StepRail = ({ step, setStep, done, errorSteps }) => {
  const pct = ((step + 1) / SECTIONS.length) * 100;
  return (
    <nav aria-label="Application sections" className="no-print" data-testid="application-step-rail">
      <div className="lg:hidden sticky top-[124px] z-10 -mx-6 sm:-mx-10 px-6 sm:px-10 py-3 bg-[#FBF8F1]/95 backdrop-blur border-b border-[#154F49]/15">
        <div className="flex items-center justify-between text-xs font-bold text-[#154F49] mb-2">
          <span>Section {step + 1} of {SECTIONS.length} · {SECTIONS[step].short}</span>
          <span className="text-[#9B742A]">{Math.round(pct)}%</span>
        </div>
        <div className="h-1.5 rounded-full bg-[#DCE3D8] overflow-hidden"><motion.div className="h-full bg-[#CDA34F]" animate={{ width: `${pct}%` }} /></div>
        <label htmlFor="step-jump" className="sr-only">Jump to section</label>
        <select id="step-jump" value={step} onChange={(e) => setStep(Number(e.target.value))} data-testid="step-jump-select" className="mt-2 w-full text-sm bg-white border border-[#154F49]/30 rounded-lg px-3 py-2 text-[#154F49]">
          {SECTIONS.map((s, i) => <option key={s.id} value={i}>{s.id} — {s.title}{errorSteps.has(i) ? " (needs attention)" : done.has(i) ? " ✓" : ""}</option>)}
        </select>
      </div>
      <ol className="hidden lg:block sticky top-32 space-y-1">
        <li className="mb-4">
          <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#9B742A]">Your progress</p>
          <div className="mt-2 h-1.5 rounded-full bg-[#DCE3D8] overflow-hidden"><motion.div className="h-full bg-[#CDA34F]" animate={{ width: `${pct}%` }} /></div>
        </li>
        {SECTIONS.map((s, i) => {
          const active = i === step, ok = done.has(i), bad = errorSteps.has(i);
          return (
            <li key={s.id}>
              <button type="button" onClick={() => setStep(i)} aria-current={active ? "step" : undefined} data-testid={`step-btn-${s.id}`}
                className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-left transition-colors ${active ? "bg-[#154F49] text-[#FBF8F1]" : "hover:bg-[#EDF1E6] text-[#1A2E2B]"}`}>
                <span className={`w-7 h-7 shrink-0 rounded-full flex items-center justify-center text-[11px] font-bold border ${bad ? "border-red-700 text-red-800 bg-red-50" : ok ? "bg-[#CDA34F] border-[#CDA34F] text-[#154F49]" : active ? "border-[#E2C372] text-[#E2C372]" : "border-[#154F49]/30 text-[#154F49]"}`}>
                  {ok && !bad ? <Check className="w-3.5 h-3.5" /> : s.id}
                </span>
                <span className="text-sm font-semibold leading-tight">{s.short}</span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
